module.exports = __webpack_public_path__ + "static/media/_left_quote.9aed637e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/alphabet/_left_quote.jpg
// module id = 58
// module chunks = 0